import { List, Skeleton } from '@factorialco/deprecated-design-system'
import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import Item from './_Item'

interface Props {
  approvalGroups: ApprovalsGroupFragment[]
  loading: boolean
  canEdit: boolean
  canDelete: boolean
}

const ApprovalGroupsSkeleton = () => (
  <List>
    {[...Array(3)].map((_, index) => (
      <List.Item key={index}>
        <Skeleton width="s300" height="s12" />
      </List.Item>
    ))}
  </List>
)

const ApprovalGroups = ({ approvalGroups, loading, canEdit, canDelete }: Props) => {
  if (loading) {
    return <ApprovalGroupsSkeleton />
  }

  return (
    <List>
      {approvalGroups.map((group) => (
        <List.Item key={group.id}>
          <Item group={group} key={group.id} canEdit={canEdit} canDelete={canDelete} />
        </List.Item>
      ))}
    </List>
  )
}

export default ApprovalGroups
